import { useRefreshMiners } from "../useRefreshMiners";
import { IRefreshMinersProps } from "./RefreshMiners.props";

export const useRefreshMinersControl = (props: IRefreshMinersProps) => {
  const { refresher, loading } = useRefreshMiners();
  const onRefresh = async () => {
    refresher();
  };

  return {
    onRefresh,
    loading,
  };
};
